/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PromptScheduleModel } from '../../models/prompt-schedule-model';

export interface GetPromptSchedules$Params {
  patientID?: number;
  onlyActive?: boolean;
}

export function GetPromptSchedules(http: HttpClient, rootUrl: string, params?: GetPromptSchedules$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<PromptScheduleModel>>> {
  const rb = new RequestBuilder(rootUrl, GetPromptSchedules.PATH, 'get');
  if (params) {
    rb.query('patientID', params.patientID, {});
    rb.query('onlyActive', params.onlyActive, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<PromptScheduleModel>>;
    })
  );
}

GetPromptSchedules.PATH = '/api/Supervisor/GetPromptSchedules';
